import '../css/bottom.scss'
import '../css/consultant.scss'
import '../css/faq.scss'
import '../css/sidebar.scss'
import {changeExpander} from "./expander";

/*                                                             */
changeExpander();

/*                                                */
window.addEventListener('resize', changeExpander);



